(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["7th-anniversary-img-text"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", () => {
  // notify弹出弹窗
  $(".img-text .notify-btn").click(function () {
    $(".img-text .notify-window").css("display", "flex");
  });

  //  弹窗关闭按钮
  $(".close-icon").click(function () {
    $(this).parent(".notify-window").css("display", "none");
  });
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["7th-anniversary-nav"] && !Shopify.designMode) return;
  try {
     
$(document).ready(function() {
  $('.copy').click(function() {
    var $btn = $(this);
    var $code = $btn.siblings('.code');
    var textToCopy = $.trim($code.text());

    navigator.clipboard.writeText(textToCopy).then(function() {
      var originalText = $btn.text();
      $btn.text("✔ COPIED");
      $btn.css("backgroundColor", "#121212");
      $btn.css("color", "white");

      // setTimeout(function() {
      //   $btn.text(originalText);
      //   $btn.css("backgroundColor", "");
      //   $btn.css("color", "");
      // }, 3000);
    }).catch(function(err) {
      console.error('Copy Failed：', err);
    });
  });
});

document.addEventListener("DOMContentLoaded", () => {
  // notify弹出弹窗
  $(".holiday-sale-nav-wrapper .notify-btn").click(function () {
    $(".holiday-sale-nav-wrapper .notify-window").css("display", "flex");
  });

  //  弹窗关闭按钮
  $(".close-icon").click(function () {
    $(this).parent(".notify-window").css("display", "none");
  });
});



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["7th-anniversary-reward"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", () => {
    // notify弹出弹窗
    $(".reward .notify-btn").click(function () {
      $(".reward .notify-window").css("display", "flex");
    });
  
    //  弹窗关闭按钮
    $(".close-icon").click(function () {
      $(this).parent(".notify-window").css("display", "none");
    });
  });
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["7th-anniversary-sale-getoff"] && !Shopify.designMode) return;
  try {
     
document.addEventListener("DOMContentLoaded", function () {
  const viewMoreBtn = document.querySelector('.view-more-btn');
  if (!viewMoreBtn) return;

  const productBlocks = document.querySelectorAll('.holiday-sale-get-off .product-list-wrapper .product-list .product-block');
  const arrow = viewMoreBtn.querySelector('svg, img, span:last-child');

  let expanded = false;

  viewMoreBtn.addEventListener('click', function () {
    expanded = !expanded;

    if (expanded) {
      productBlocks.forEach(block => block.classList.add('show'));
      viewMoreBtn.querySelector('span').textContent = 'View Less';
      arrow.style.transform = 'rotate(180deg)';
    } else {
      productBlocks.forEach((block, index) => {
        if (index >= 4) block.classList.remove('show'); // 只保留前 4 个
      });
      viewMoreBtn.querySelector('span').textContent = 'View More';
      arrow.style.transform = 'rotate(0deg)';
    }
  });
});



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.body = document.querySelector('body');
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      // this.closeSearchModal();
      this.body.style.setProperty('--dynamic-header-height', '0px');
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
      this.body.style.setProperty('--dynamic-header-height', `${this.header.offsetHeight}px`);
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
      this.body.style.setProperty('--dynamic-header-height', `${this.header.offsetHeight}px`);
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
